import { createRouter, createWebHistory, RouteRecordRaw } from 'vue-router'
import HomeView from '../views/HomeView.vue'
import cardVoucher from '../views/cardVoucher/index.vue'
import dynamics from '../views/dynamics/index.vue'
import cooperation from '../views/cooperation/index.vue'
import login from '../views/login/index.vue'
import personalCenter from '../views/personalCenter/index.vue'
import searchPage from '../views/searchPage/index.vue'
import official from '../views/official/index.vue'
import recovery from '../views/login/recovery.vue'
import aboutUs from '../views/aboutUs/index.vue'
import news from '../views/news/index.vue'
import newsDetail from '../views/newsDetail/index.vue'
import articleDetail from '../views/articleDetail/index.vue'

const routes: Array<RouteRecordRaw> = [
  {
    path: '/',
    name: 'home',
    component: HomeView
  },
	{
	  path: '/cardVoucher',
	  name: 'cardVoucher',
	  component: cardVoucher,
		meta: { isAuth: true },
	},
	{
	  path: '/dynamics',
	  name: 'dynamics',
	  component: dynamics
	},
	{
	  path: '/cooperation',
	  name: 'cooperation',
	  component: cooperation
	},
	{
	  path: '/login',
	  name: 'login',
	  component: login
	},
	{
	  path: '/personalCenter',
	  name: 'personalCenter',
	  component: personalCenter,
		meta: { isAuth: true },
	},
	{
	  path: '/searchPage',
	  name: 'searchPage',
	  component: searchPage,
	},
	{
	  path: '/official',
	  name: 'official',
	  component: official,
	},
	{
	  path: '/recovery',
	  name: 'recovery',
	  component: recovery,
	},
	{
	  path: '/aboutUs',
	  name: 'aboutUs',
	  component: aboutUs,
	},
	{
	  path: '/news',
	  name: 'news',
	  component: news,
	},
	{
	  path: '/newsDetail',
	  name: 'newsDetail',
	  component: newsDetail,
	},
	{
	  path: '/articleDetail',
	  name: 'articleDetail',
	  component: articleDetail,
	}
]

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes
})


router.beforeEach((to, from, next) => {
  // 判断是否需要鉴权
  if (to.meta.isAuth) {
    // 验证用户权限
		console.log(localStorage.getItem('londEssage'));
    if (localStorage.getItem('londEssage')) {
      next(); // 放行
    } else {
      alert('对不起，您还未登陆');
      next('/'); // 重定向到登录页面
    }
  } else {
    next(); // 不需要鉴权，直接放行
  }
});

export default router
